import React, { HTMLAttributes } from "react";
import { colors } from "./constants";
import styled from "styled-components";
import { mediaQuery } from "./constants";
import { AbsoluteWrapper } from "./standard";

export const IconRightArrow = () => {
  return (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6754 5.2702H0" stroke="currentColor" strokeWidth="0.5" />
      <path d="M6.93945 1L10.6758 5.27015L6.93945 9.5403" stroke="currentColor" strokeWidth="0.5" />
    </svg>
  );
};

export const ScrollIcon = () => {
  return (
    <svg width="24" height="37" viewBox="0 0 24 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.65898"
        y="0.7"
        width="20.6617"
        height="35.344"
        rx="10.3309"
        stroke="white"
        strokeWidth="1.4"
      />
      <rect x="10.6641" y="7.93652" width="2.64741" height="6.173" rx="1.3237" fill="white" />
    </svg>
  );
};

export const PlayButtonIcon = () => {
  return (
    <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49.9351 36.5876C51.2871 37.3537 51.2871 39.3016 49.9351 40.0677L32.4857 49.9555C31.1524 50.711 29.4997 49.7479 29.4997 48.2155L29.4997 28.4398C29.4997 26.9074 31.1524 25.9442 32.4857 26.6998L49.9351 36.5876Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <circle cx="38" cy="38" r="37" stroke="white" strokeWidth="2" />
    </svg>
  );
};

export const IconDownChevron = () => {
  return (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L7 7L13 1" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
};

interface Props {
  onClick?: () => void;
  height?: string;
}

export const PlayButton = ({ onClick, height }: Props) => {
  const PlayButtonWrapper = styled(AbsoluteWrapper)`
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 5;
    height: ${height};
    svg {
      transform: scale(1);
      transition: 0.2s;
    }

    &:hover {
      svg {
        transform: scale(1.2);
      }
    }

    ${mediaQuery.smallDown} {
      svg {
        transform: scale(0.7);
      }
    }
  `;

  return (
    <PlayButtonWrapper onClick={() => onClick && onClick()}>
      <PlayButtonIcon />
    </PlayButtonWrapper>
  );
};

export const IconSearch = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8297 15.9718L10.7814 9.92353C12.9058 7.32533 12.5217 3.49695 9.92353 1.37256C7.32537 -0.751836 3.49695 -0.367725 1.37256 2.23043C-0.751836 4.82859 -0.367725 8.65701 2.23044 10.7814C4.46838 12.6112 7.68559 12.6112 9.92353 10.7814L15.9718 16.8297C16.2129 17.0625 16.5969 17.0558 16.8297 16.8148C17.0568 16.5796 17.0568 16.2069 16.8297 15.9718ZM6.08669 10.9403C3.40733 10.9373 1.23601 8.76604 1.23303 6.08669C1.23303 3.40609 3.40609 1.23303 6.08669 1.23303C8.76729 1.23303 10.9404 3.40609 10.9404 6.08669C10.9404 8.76728 8.76729 10.9403 6.08669 10.9403Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconBurger = (attributes: HTMLAttributes<any>) => {
  return (
    <svg
      width="25"
      height="18"
      viewBox="0 0 25 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-burger"
      {...attributes}
    >
      <line y1="1" x2="25" y2="1" stroke="currentColor" strokeWidth="2" />
      <line y1="9" x2="25" y2="9" stroke="currentColor" strokeWidth="2" />
      <line y1="17" x2="25" y2="17" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
};

export const IconCloseCircle = (attributes: any) => {
  return (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-close-circle"
      {...attributes}
    >
      <circle cx="23.5" cy="23.5" r="23.5" fill={`${colors.primary}`} />
      <rect width="25" height="18" transform="translate(12 15)" fill={`${colors.primary}`} />
      <line
        x1="15.6602"
        y1="31.4256"
        x2="31.9236"
        y2="15.1622"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="16.4142"
        y1="15"
        x2="32.6777"
        y2="31.2635"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
interface ArrowProps {
  flip?: boolean;
  onClick?: () => void;
  darkMode?: boolean;
  customArrow?: boolean;
  height?: string;
  width?: string;
}

export const CircleArrow = ({
  flip,
  onClick,
  darkMode,
  customArrow,
  height,
  width,
}: ArrowProps) => {
  const ArrowWrapper = styled.div<{
    flip?: boolean;
    darkMode?: boolean;
    customArrow?: boolean;
    width?: string;
    height?: string;
  }>`
    ${({ flip }) => flip && `transform: rotateZ(180deg);`};
    ${({ darkMode }) => darkMode && `filter: invert(1);`};
    ${({ customArrow }) => customArrow && `display:flex;`};
    ${({ customArrow }) => (customArrow ? `` : `height: 59px;`)};
    ${({ height }) => height && `height: ${height};`};
    ${({ width }) => width && `width: ${width};`};
    cursor: pointer;
    svg {
      transform: scale(1);
      transition: 0.2s;
    }

    &:hover {
      svg {
        transform: scale(1.2);
      }
    }

    ${mediaQuery.smallDown} {
      top: 40%;
      svg {
        transform: scale(0.7);
      }
      &:hover {
        svg {
          transform: scale(0.7);
        }
      }
    }
  `;

  return (
    <ArrowWrapper
      flip={flip}
      height={height}
      width={width}
      customArrow={customArrow}
      onClick={() => onClick && onClick()}
      darkMode={darkMode}
    >
      {customArrow ? (
        <svg
          width="32"
          height="23"
          viewBox="0 0 32 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.4652 12.6401C32.051 12.0543 32.051 11.1046 31.4652 10.5188L21.9193 0.972866C21.3335 0.387079 20.3837 0.387079 19.7979 0.972866C19.2122 1.55865 19.2122 2.5084 19.7979 3.09419L28.2832 11.5795L19.7979 20.0647C19.2122 20.6505 19.2122 21.6003 19.7979 22.1861C20.3837 22.7719 21.3335 22.7719 21.9193 22.1861L31.4652 12.6401ZM0 13.0795L30.4045 13.0795V10.0795L0 10.0795L0 13.0795Z"
            fill="#E4007E"
          />
        </svg>
      ) : (
        <svg
          width="59"
          height="59"
          viewBox="0 0 59 59"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="29.5" cy="29.5" r="28.5" stroke="white" strokeWidth="2" />
          <g clipPath="url(#clip0_2_1484)">
            <path
              d="M27.918 41.75C28.1132 41.7513 28.3044 41.6955 28.4683 41.5895C28.6321 41.4834 28.7613 41.3317 28.84 41.1531C28.9186 40.9745 28.9433 40.7768 28.911 40.5843C28.8786 40.3919 28.7907 40.2131 28.658 40.07L19.718 30.37L28.658 20.67C28.8174 20.4722 28.8956 20.2211 28.8766 19.9677C28.8576 19.7144 28.7429 19.4778 28.5558 19.3059C28.3687 19.1341 28.1232 19.0399 27.8691 19.0425C27.6151 19.0451 27.3715 19.1443 27.188 19.32L16.998 30.37L27.188 41.43C27.2812 41.5305 27.3942 41.6108 27.5197 41.6659C27.6453 41.7209 27.7809 41.7496 27.918 41.75Z"
              fill="white"
            />
            <path
              d="M18.9081 31.3711H40.5781C40.8433 31.3711 41.0977 31.2658 41.2852 31.0782C41.4728 30.8907 41.5781 30.6363 41.5781 30.3711C41.5781 30.1059 41.4728 29.8515 41.2852 29.664C41.0977 29.4765 40.8433 29.3711 40.5781 29.3711H18.9081C18.6429 29.3711 18.3886 29.4765 18.201 29.664C18.0135 29.8515 17.9081 30.1059 17.9081 30.3711C17.9081 30.6363 18.0135 30.8907 18.201 31.0782C18.3886 31.2658 18.6429 31.3711 18.9081 31.3711Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2_1484">
              <rect
                width="24.58"
                height="22.75"
                fill="white"
                transform="matrix(-1 0 0 1 41.5781 19)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </ArrowWrapper>
  );
};
